import React from 'react'
import "./Feed.css";
import StoryReel from "./StoryReel";
import MessageSender from "./MessageSender";
import Post from "./Post";
import db from './firebase';

function Feed() {

   

   

    return (
    <div className="feed">
            <StoryReel/>
            <MessageSender/>
            {/*messageSender*/ }

            <Post
          
            profilePic="https://lh3.googleusercontent.com/a-/AOh14Gjnn16TBvBzx-1ddZfMODkEGKd4RnBmgOXZ6QSE2A=s600-k-no-rp-mo"
            message="Wow"
            timestamp="timestamp"
            username="txsingh"
            image="https://images.unsplash.com/photo-1494548162494-384bba4ab999?ixid=MXwxMjA3fDB8MHxzZWFyY2h8MXx8c3VucmlzZXxlbnwwfHwwfA%3D%3D&ixlib=rb-1.2.1&w=1000&q=80"
            />
            
            
            <Post
            
            profilePic="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcS3lv97wSw7lDljgjOfvnzb_om4OamXIxaISw&usqp=CAU"
            message="New Day"
            timestamp="timestamp"
            username="End_boy"
            image="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQyBpNNrwyUOtenZsI9PIRqRWC6GgwA4CZ1Mw&usqp=CAU"/>

            <Post
            
            profilePic="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQtZ2d4QlIa1l8pl7ISoGf1FBV4iVOTwNl1bw&usqp=CAU"
            message="Hey wow this it lit!!"
            timestamp="timestamp"
            username="sunshine"
            image="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSYFHiVZAsJGjaQMZH7Za8IQe0SwlAkVTJiNA&usqp=CAU"/>
        </div>
    );
}

export default Feed
